<template>
    <div>
       
        <div  class="g_desktopOn smenuTool" v-show="!configMembreModal">
            <div class="title is-4" style="float:left;padding-left:20px" v-if="club" >  
                <s-l id="club_titlemembre" :v="club.name">Les Membres du club %v</s-l>
            </div>
            <div class="buttonOperation">
                <s-button 
                
                label="Opérations" icon="" theme="is-primary" icon="users"
                @onclick="modalOperation=true"/> 
            </div>
            <div class="buttonOperationRoles">
                <s-button label="Rôles" @onclick="modalRoles=true;userLegend=null;numLegend=null" theme="is-info" icon="question"/>
            </div>
           
            <div class="buttonHelp">
                <s-you-tube id="video_membre" :club="club"  />
            </div>
            <div style="float:right;padding-bottom: 0px"  v-if="!configMembreModal" >
                  <s-button 
                    :icon="nbDemandes==0 ? 'signature' : 'exclamation-triangle'" 
                    :theme="nbDemandes==0 ? 'is-primary is-small' : 'is-danger is-small'" 
                    :label="nbDemandes==0 ? 'Demandes d adhésion' : nbDemandes + ' demandes d adhésion'" 
                    @onclick="listDemandes" v-if="club!=null"/>&nbsp;
                <s-button label="Importer" icon="upload"                
                    theme="is-primary is-small" @onclick="importClient=true" :role="getRole(club)" />&nbsp;
                <export-membres :club="club" v-if="club!=null" ref="exportMembre"/>&nbsp;
                <s-button label="Configuration" 
                    icon="cog"                
                    theme="is-primary is-small" 
                    @onclick="configMembreModal=!configMembreModal" :role="getRole(club)" 
                    />&nbsp;
                 
            </div>
            
        </div>
        
        <div  class="buttonAdhesion g_mobileOn" v-if="!configMembreModal">
            <s-button 
                    :icon="nbDemandes==0 ? 'signature' : 'exclamation-triangle'" 
                    :theme="nbDemandes==0 ? 'is-primary is-small' : 'is-danger is-small'" 
                    :label="nbDemandes==0 ? 'Demandes d adhésion' : nbDemandes + ' demandes d adhésion'" 
                    @onclick="listDemandes" v-if="club!=null"/>&nbsp;
            
        </div>
        <div class="g_mobileOn buttonMobileVideo">
            <s-you-tube id="video_membre" :club="club" theme="is-info is-small" />
        </div>

        <config-membre
                v-if="configMembreModal && club.id!='' && club!=null"
                @close="configMembreModal=false"
                :club="club"
            />
        <div class="listJoueurs">
            
            
            <import-membres :club="club" 
                @close="importClient=false"
                title="Importer les membres"
                :open="importClient"
                :close="true"
                v-if="club!=null"
            />
            
            <joueurs
                :club="club"
                :role="getRole(club)"
                :selection="selection"
                :saison="null"
                v-if="club!=null &&  !configMembreModal"
                :options="{membre: true}"
                titleMobile="Les membres du club"
                @import="importClient=true"
                @export="exportMembre()"
                @config="configMembreModal=true"
                @supSelect="selection=[]"
                ref="listJoueurs"
            />
        </div>
       
         <s-modal 
                :open="modalOperation"
                @close="modalOperation=false"
                :close="true"
                :title="'Opérations sur '+selection.length+' membres'"
            >
                <div class="buttonItemOperation">
                    <s-button theme="is-success" label="Sélectionner tout" icon="check" @onclick="selectionner"/>
                    &nbsp;<s-button theme="is-warning" label="Désélectionner tout" icon="times" @onclick="deselectionner"/>
                </div>
                <div class="buttonItemOperation">
                    <s-button 
                    :disabled="selection.length==0"
                    theme="is-danger" 
                    @onclick="confirmDelete=true"
                    icon="trash" :label="'Supprimer les '+selection.length+' membres selectionnés'"/>
                    
                </div>
                <div class="buttonItemOperation">
                    <s-button 
                    :disabled="selection.length==0"
                    theme="is-primary" 
                    @onclick="openModalTags"
                    icon="user-tag" :label="'Affecter un tag aux '+selection.length+' membres selectionnés'"/>
                    
                </div>
                <s-modal
                    :open="modalTags"
                    @close="modalTags=false"
                    :close="true"
                    title="Affecter un tag à plusieurs membres"
                >
                    <div v-if="club">
                    <div v-for="custom in club.customs">
                        <div class="label formJoueur">
                            {{custom.label}}
                        </div>
                        <span v-if="custom.type!='radio' && custom.type!='checkbox'">
                            <input :name="custom.id" :type="custom.type" class="input is-light is-rounded is-normal" 
                            style="width:300px"
                             v-model="customs[custom.id]"  />
                        </span>
                        <span v-if="custom.type=='radio' || custom.type=='checkbox'">
                            <label :class="custom.type" v-for="(value, index) in custom.values">
                                <input
                                    :name="custom.id" 
                                    :type="custom.type" :value="index" 
                                    v-model="customs[custom.id]" /> 
                            
                                {{value}}
                            </label>
                        </span>
                    </div>
                    <div >
                        <s-button
                            icon="save"
                            label="Mettre à jour les tags"
                            @onclick="updateTags"
                            theme="is-primary"/>
                    </div>
                    </div>
                </s-modal>
                 <s-confirm
                        :open="confirmDelete"
                        @yes="deleteSelection"
                        @no="confirmDelete=false"
                    >
                        <s-l id="confirmDeleteSelection" :v="selection.length">Souhaitez vous supprimer les %v membres ?</s-l>
                    </s-confirm>
         </s-modal>
          <s-modal    
                :open="modalRoles"
                :close="true"
                @close="modalRoles=false">
                <div>
                    Pour changer le rôle d'un membre, il faut ouvrir sa fiche et cliquer sur l'onglet <b>Rôles</b>
                </div>
                <div  v-show="!configMembreModal">
                    <div class="legend">
                        <span class="icon-text">
                            <span class="icon has-text-danger">
                                <i class="fas fa-user-tie "></i>
                            </span>
                            <span>&nbsp;Gestionnaire du club</span>
                        </span>
                        <span style="float:right">
                        <s-button icon="user"  label="" 
                             :theme="userLegend==0 ? 'is-small is-success' : 'is-small is-primary'"
                             @onclick="openLegendUser(0)"/>  &nbsp;
                            <s-button icon="info"  label="" 
                            :theme="numLegend==0 ? 'is-small is-success' : 'is-small is-primary'"
                             @onclick="setNumLegend(0)"/>
                            
                              
                        </span>
                        <div v-show="numLegend==0">
                            Il n'y a <b>qu'un seul</b> GESTIONNAIRE par club.<br/>
                            Il a tous les droits, il est lui aussi ORGANISATEUR de concours<br/>
                            <li><b>Si le club possède un abonnement, il peut créer des concours sans avoir besoin de crédits.</b></li>
                            <li><b style="color:red">Si le club ne possède pas d'abonnement, c'est le seul à pouvoir créer des concours mais avec ses propres CREDITS</b></li>
                        
                        </div>
                         <div v-show="userLegend==0">
                            <b>Le gestionnaire du club est :</b>
                            <div v-for="user in usersLegend">
                                {{user.prenom}} {{user.nom}} ({{user.email}})
                            </div>
                            <div v-if="clubIsSubscription()" class='infoClubLegend'>
                               Le club possède un abonnement, il peut (avec les organisateurs) créer des concours sans avoir besoin de crédits
                            </div>
                            <div v-if="!clubIsSubscription()" class='infoClubLegend'>
                               Le club ne possède pas d'abonnement, c'est le seul à pouvoir créer des concours avec ses propres crédits
                            </div>
                        </div>
                    </div>
                    <div class="legend">
                        <span class="icon-text">
                            <span class="icon has-text-info">
                                <i class="fas fa-user-graduate "></i>
                            </span>
                            <span>&nbsp;Organisateur de concours</span>
                        </span>
                        <span style="float:right">
                         <s-button icon="users"  label="" 
                            :theme="userLegend==1 ? 'is-small is-success' : 'is-small is-primary'"
                             @onclick="openLegendUser(1)"/> &nbsp;
                            <s-button icon="info"  label="" 
                            :theme="numLegend==1 ? 'is-small is-success' : 'is-small is-primary'"
                             @onclick="setNumLegend(1)"/> 
                             
                        </span>
                        <div v-show="numLegend==1">
                           
                            
                                <li><b>Si le club possède un abonnement, il peut créer et organiser des concours. (sans crédits)</b></li>
                                <li><b style="color:red">Si le club ne possède pas d'abonnement, il ne peut pas créer de concours, seul le GESTIONNAIRE peut le faire.
                                Il pourra cependant organiser des concours qui ont été crées au préalable par le GESTONNAIRE<br/></b></li>
                            
                            Il peut ajouter des membres mais il ne peut pas leurs attribuer de rôles.
                        </div>
                        <div v-show="userLegend==1">
                            <div v-if="usersLegend.length>0">
                                <b>Les organisateurs sont :</b>
                                <div class="listOrganisateurs">
                                    <div v-for="user in usersLegend" style="margin-left:10px">
                                        {{user.prenom}} {{user.nom}} ({{user.email}})
                                    </div>
                                </div>
                                <div v-if="clubIsSubscription()" class='infoClubLegend'>
                                Le club possède un abonnement, ils peuvent créer des concours (sans avoir besoin de crédits)
                                </div>
                                <div v-if="!clubIsSubscription()" class='infoClubLegend'>
                                Le club ne possède pas d'abonnement, ils ne peuvent pas créer des concours. Seul le gestionnaire peut créer des concours avec ses propres crédits. Les organisateurs peuvent néanmoins organiser des concours qui ont été crée au préalable par le gestionnaire.
                                </div>
                            </div>
                            <div  v-if="usersLegend.length==0">
                                Il n'y a pas d'organisateurs. Seul le GESTIONNAIRE peut le faire
                            </div>
                             
                        </div>
                    </div>
                    <div class="legend">
                        <span class="icon-text">
                            <span class="icon has-text-success">
                                <i class="fas fa-user-check "></i>
                            </span>
                            <span>&nbsp;Membre connecté <i>(email renseigné)</i></span>
                        </span>
                        <span style="float:right">
                        
                            <s-button icon="info" label=""
                            :theme="numLegend==2 ? 'is-small is-success' : 'is-small is-primary'"
                             @onclick="setNumLegend(2)"/> 
                             
                        </span>
                        <div v-show="numLegend==2">
                            Si son mail est renseigné, un membre peut se connecter et rentrer dans le club<br/>
                            Il peut voir les concours, voir le classement (concours & saison).<br/>
                            Tout est en lecture. Il ne peut rien modifier<br/>
                            Si il le souhaite, il pourra saisir le score de ses parties (avec la validation de l'organisateur ou du gestionnaire)<br/>
                        </div>
                    </div>
                    <div class="legend">
                            <span class="icon-text">
                                <span class="icon">
                                    <i class="fas fa-user-slash"></i>
                                </span>
                                <span>&nbsp;Membre non connecté <i>(email non renseigné)</i></span>
                            </span>
                            <span style="float:right">
                            <s-button icon="info"  label="" 
                                      :theme="numLegend==3 ? 'is-small is-success' : 'is-small is-primary'" @onclick="setNumLegend(3)"/> 
                        </span>
                        <div v-show="numLegend==3">
                            Un membre qui ne possède pas d'email pourra se connecter en tant que VISITEUR si et seulment si le club est PUBLIC<br/>
                            Il lui faudra toutefois saisir un CODE délivré par le gestionnaire pour accèder aux différents concours et classements
                        </div>
                    </div>
                    
                    
                   
                </div>
           </s-modal>
</div>
      
  
</template>
<style scoped>
    .infoClubLegend {
            font-style: italic;
            font-size: 14px;
    }
    .listOrganisateurs {
        overflow-y: auto;
        height: 200px;
        margin: 2px;
        border: thin dashed black;
        padding: 5px;
    }
    .buttonItemOperation {
        margin-top: 20px;
    }
    .buttonAdhesion {
        position: fixed;
        top: 70px;
        right: 5px;
        z-index: 2;
        
    }
    .buttonMobileVideo {
        position: fixed;
        margin-top: -100px;
        margin-left: 10px;
        z-index: 2;
    }
    @media screen and (min-width: 420px) {  
        .listJoueurs {
            margin-top: 120px;
            
        }
    }
    @media screen and (max-width: 420px) {  
        .listJoueurs {
            margin-top: 30px;
            width: 100%;
            text-align: center;
        }
    }
    .legend {
        border: thin solid black;
        padding: 8px;
        margin-bottom: 2px;
    }
    .buttonHelp {
        float: right;
         top: 100px; 
        right: 0px;
        position: fixed; 
    }
    .buttonOperation {
         position: fixed; 
         top: 110px; 
         right: 150px; 
         margin-left: -230px;
    }
    .buttonOperationRoles {
         position: fixed; 
         top: 110px; 
         right: 20px; 
         margin-left: -230px;
    }
    .smenuTool {
        position: fixed;
        top: 50px;
        padding-top: 15px;
        background-color:  var(--backgound-color);
        width: 100%;
        height: 120px;
        box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        -webkit-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
        -moz-box-shadow: 0px 7px 7px -5px rgba(0,0,0,0.71);
         z-index: 2;
    }
    
</style>
<script>
import joueurs from "@/views/joueurs/list.vue"
import firebase_api from "@/firebase/firebase_api"
import joueur_fct from "@/firebase/joueur"
import configMembre from "@/views/club/configMembre.vue"
import importMembres from "@/views/club/importMembres.vue"
import exportMembres from "@/views/club/exportMembres.vue"
export default {
    components: {
        joueurs,
        configMembre,
        importMembres,
        exportMembres
    },
    computed: {
        nbDemandes: {
            get() {
                var demandes = 0;
                if (this.club!=null) {
                    if (typeof(this.club.demandes)!="undefined")
                        demandes = this.club.demandes
                }
                return demandes;
            }
        }
    },
    data() {
        return {
            configMembreModal: false,
            importClient: false,
            club: null,
            selection: [],
            modalOperation : false,
            confirmDelete: false,
            modalTags: false,
            customs: {},
            modalRoles: false,
            numLegend: null,
            usersLegend: [],
            userLegend: null
        }
    },
    mounted() {
        var idClub = this.$route.params.id;
        this.$bind("club", firebase_api.api.getDb().collection('club').doc(idClub))
    },
    methods: {
        clubIsSubscription() {
            if (this.club!=null) {
            if (typeof(this.club.subscription) != "undefined")
                    if (this.club.subscription.status == "active") {
                        var date = new Date();
                        var endDate = this.club.subscription.period_end.toDate();
                        var startDate =  this.club.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
            }
            else
                return false;
        },
        openLegendUser(numLegend) {
            this.numLegend = null;
            
            if (numLegend==this.userLegend)
                this.userLegend=null;
            else
                this.userLegend=numLegend;
            this.usersLegend = [];
            if (this.userLegend<2) {
                var joueurs = this.$refs.listJoueurs.joueurs;
                for (var idUser in this.club.users) {
                    var user = this.club.users[idUser]
                    if (numLegend==0 && user.role=='owner') {
                        var joueur = joueurs.find(elt=>elt.userId === user.id) 
                        if (typeof(joueur)!="undefined")
                            this.usersLegend.push(joueur)
                        else {
                            var joueur = this.club.users[idUser];
                            joueur.nom = joueur.pseudo;
                            this.usersLegend.push(joueur);
                        }
                    }
                        
                    else if (numLegend==1 && user.role=='admin') {
                        var joueur = joueurs.find(elt=>elt.userId ===  user.id) 
                        if (typeof(joueur)!="undefined")
                            this.usersLegend.push(joueur)
                    }
                }
            }
        },
        setNumLegend(numLegend) {
             this.userLegend = null;
            if (numLegend==this.numLegend)
                this.numLegend=null;
            else
                this.numLegend=numLegend;
        },
        updateTags() {
            
            var joueurs = this.$refs.listJoueurs.joueurs;
            this.selection.forEach((idJoueur, index)=>{
                var joueur = joueurs.find(elt=>elt.id === idJoueur);
                for (var keyTag in this.customs) {
                    if (this.customs[keyTag] != "") {
                        joueur.customs[keyTag]=this.customs[keyTag] ;
                    }
                }    
                joueur_fct.object.set(this.club, joueur);
            })
            this.modalTags = false;
            this.modalOperation = false;
        },
        openModalTags() {
            this.customs = {};
            for (var keyTag in this.club.customs) {
                this.customs[keyTag] = "";
            }
            this.modalTags=true;
        },
         getRole(club) {
            return this.$getRole(club, this.$store.getters.getUser);
        },
        listDemandes() {
            this.$router.push({name: "demandes", params: {id: this.club.id}})
        },
        exportMembre() {
           
            this.$refs.exportMembre.onexport();
        },
        selectionner() {
            this.selection = this.$refs.listJoueurs.getMembersFilters();
        },
        deselectionner() {
            this.selection = []
        },
        
        deleteSelection() {
            var joueurs = this.$refs.listJoueurs.joueurs;
            this.selection.forEach((idJoueur, index)=>{
                var joueur = joueurs.find(elt=>elt.id === idJoueur);
                joueur_fct.object.delete(this.club, joueur, ()=>{
                    if (index == this.selection.length-1) {
                        this.selection = [];                                    
                       
                    }
                })
            })
            this.confirmDelete = false;
            this.modalOperation = false;
        }
    }
}
</script>
